import { render, staticRenderFns } from "./itemSubGroupTwo.vue?vue&type=template&id=f49fec7e&"
import script from "./itemSubGroupTwo.vue?vue&type=script&lang=js&"
export * from "./itemSubGroupTwo.vue?vue&type=script&lang=js&"
import style0 from "./itemSubGroupTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports